export default __webpack_public_path__ + "static/media/arrow.0cee73ce.svg";